<template>
    <div v-if="params.inputType == 'input' && !params.isShow">
        <el-input v-model="ruleForm[params.filed]" :type="params.typeValue" :placeholder="params.placeholder" :style="params.miniSize?'width:70%;':''"
         :disabled="params.disabled" :show-password="params.isShowPassword" clearable :rows="params.rows || 3" @change="(val)=>{params.change ? params.change(val) : ''}"></el-input>
    </div>
    <div v-else-if="params.inputType == 'textLabel' && !params.isShow">
        <div :style="params.styleObj" >{{ params.textValue }}</div>
    </div>
    <div v-else-if="params.inputType == 'textValue' && !params.isShow">
        <div :style="params.styleObj" >{{ ruleForm[params.filed] }}</div>
    </div>
    <div v-else-if="params.inputType == 'imgValue' && !params.isShow">
        <img  v-if="params.value && params.value != '--'"  :src="params.value" class="avatar"  @click="params.preview_img(params.value)"/>
    </div>
    <div v-else-if="params.inputType == 'imgValueList' && !params.isShow">
        <div class="divImgWrap">
            <div v-if="item" class="itemImg" v-for="(item, idx) in this.splitFile(params.value)" :key="idx">
                <img v-if="isImageType(item.type)" :src="item.url" alt="暂无图片" class="avatar" @click="params.preview_img ? params.preview_img(item.url) : ''" />
                <div v-else class="fileValueWrap">
                    <span class="fileValueName" :title="getFileName(item.url)">{{ getFileName(item.url) }}</span>
                    <button type="button" class="el-button el-button--primary el-button--mini is-plain" @click.stop="downloadFile(item.url)">
                        <span>下载</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="params.inputType == 'select'">
        <el-select v-model="ruleForm[params.filed]" :placeholder="params.placeholder" filterable
        :multiple="params.multiple"  :disabled="params.disabled" :collapse-tags="params.multiple"
        @change="(val)=>{params.change ? params.change(val) : ''}" clearable>
            <el-option
                v-for="item in params.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
        </el-select>
    </div>
    <div v-else-if="params.inputType == 'date'">
        <el-date-picker
            v-model="ruleForm[params.filed]"
            :type="params.typeValue"
            :disabled="params.disabled"
            :format="params.format"
            :value-format = "params.format"
            :default-value="params.defaultValue"
            :placeholder="params.placeholder"
            unlink-panels
            clearable
            >
        </el-date-picker>
    </div>
    <div  v-else-if="params.inputType == 'upload'" :style="params.miniSize?'width:70%;':''">
        <div v-if="params.typeValue == 'img'"  >
            <el-upload
            name="file"
            class="avatar-uploader"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :show-file-list="false"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-change="params.onChange"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :auto-upload="params.autoUpload"
            :headers = "this.$utils.uploadAction().headers"
            >
            <div v-if="!params.multiple">
                <img  v-if="params.value && params.value != '--'"  :src="params.value" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-if="params.isClose && params.value" class="close-wrap" @click.stop = "params.closeFun(params)">
                <i class="el-icon-circle-close"></i>
                </div>
                
            </div>
            <div v-else>
                <i  class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            </el-upload>
            <div v-if="params.multiple">
                <div class="divImgWrap">
                    <div v-if="item" class="itemImg" v-for="(item) in this.splitFile(params.value)">
                        <img  :src="item.url" alt="暂无图片" class="avatar" @click="params.preview_img(item.url)"/>
                        <div v-if="item" class="close-wrap" @click.stop = "params.closeFun(item)">
                        <i class="el-icon-circle-close"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="params.typeValue == 'file'">
            <el-upload
            class="upload-demo"
            name="file"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
        </div>
         <!-- 文件上传  不限制格式  可以多选      如果是图片就显示图片，是其他格式文件，就显示文件，并显示下载按钮 -->
        <div v-else-if="params.typeValue == 'fileArbitrarily'">
            <el-upload
            class="upload-demo"
            name="file"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :show-file-list="false"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button v-if="!params.disabled" size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
            <div class="fileArbitrarilyWrap">
                <div class="disFlex">
                    <div  v-if="item.type == 'png' || item.type == 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <!-- <img :src="item.url" class="avatar"> -->
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.url" 
                            :preview-src-list="[item.url]">
                        </el-image>
                        <div  class="close-wrap" @click.stop = "params.closeFun(item)">
                            <i class="el-icon-circle-close"></i>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div  v-if="item.type != 'png' && item.type != 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <div class="disFlex">
                            <span class="marR10">{{ item.name }}</span>
                            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                            <span   class="close-wrap-f"  @click.stop = "params.closeFun(item)">
                                <i class="el-icon-circle-close"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <!-- 文件上传  不限制格式  可以多选      如果是图片就显示图片，是其他格式文件，就显示文件  -->
        <div v-else-if="params.typeValue == 'fileArbitrarily_close'">
            <el-upload
            class="upload-demo"
            name="file"
            ref="fileArbitrarily"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :show-file-list="false"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
            <div class="fileArbitrarilyWrap">
                <div class="disFlex">
                    <div  v-if="item.type == 'png' || item.type == 'jpg' || item.type == 'bmp'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <img :src="item.url" class="avatar">
                        <div  class="close-wrap" @click.stop = "params.closeFun(item)">
                            <!-- <i class="el-icon-circle-close"></i> -->
                            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div  v-if="item.type != 'png' && item.type != 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <div class="disFlex">
                            <span class="marR10">{{ item.name }}</span>
                            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                            <!-- <span   class="close-wrap-f"  @click.stop = "params.closeFun(item)">
                                <i class="el-icon-circle-close"></i>
                            </span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
            ruleForm:{
                type: Object,
                default: function(){
                    return {}
                }
            }
        },
        data() {
            return {
            }
        },
        created () {

        },
        methods: { //附件下载
            downloadFile(url){
                let that = this;

                if(!url || url == '--'){
                    return that.$utils.msg('暂无下载链接',"error")
                }
                const link = document.createElement("a");
                link.href = url ;
                link.download = that.getFileName(url);
                link.target = "_blank"
                link.click();
            },
            isImageType(type){
                if(!type) return false;
                const fileType = type.split(/[?#]/)[0].toLowerCase();
                return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg'].indexOf(fileType) > -1;
            },
            getFileName(url){
                if(!url) return '';
                const fileName = url.split(/[?#]/)[0].split('/').pop() || '';
                try {
                    return decodeURIComponent(fileName);
                } catch (e) {
                    return fileName;
                }
            },
            reverseName(str,format){
                if(!str) return;
                let fileName = "";
                let reverseStr = str.split("").reverse().join("");
                let strSplit = reverseStr.split(format)[0];
                fileName = strSplit.split("").reverse().join("");
                return fileName;
            },
            /*splitFile(fileStr){
                if(fileStr==null || fileStr=="")
                 return []
                let that = this;
                let fileList = [];
                fileList = fileStr.split(",");
                fileList = fileList.map((item)=>{
                    return {
                        name: that.reverseName(item,"/") || "",
                        url:item || "",
                        type:that.reverseName(item,".") || "",
                    }
                })
                return fileList;
            },*/
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            reverseNameType(str,format){
                if(!str) return;
                let fileName = "";
                let reverseStr = str.split("").reverse().join("");
                let strSplit = reverseStr.split(format)[0];
                fileName = strSplit.split("").reverse().join("");
                return fileName;
            },
            splitFile(fileStr){
                //console.log("fileStr",fileStr);
                let that = this;
                let fileList = [];
                if(!fileStr) 
                 return fileList;
                fileList = fileStr.split(",");
                fileList = fileList.filter(item => item!=null && item != "" && item!=" ").map((item)=>{
                    //if(item!=null && item != "" && item!=" " )
                    return {
                        name: that.reverseName(item,"/") || "",
                        url:item || "",
                        type:that.reverseNameType(item,".") || "",
                    }
                })
                console.log("fileStr",fileStr,fileList);
                return fileList;
            },
        },
    }
</script>

<style lang="scss" scoped>
   /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  /deep/.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
   
  .fileArbitrarilyWrap{
    margin-top: 10px;
    .disFlex{
        display: flex;
        align-items: center;
    }
    .marR10{margin-right: 10px;}
    .res{
        position: relative;
    }
    .close-wrap-f{
        cursor: pointer;
        width:25px;
        height:25px;
        background:#fff;
        border-radius:50%;
        z-index:999;
        /deep/ .el-icon-circle-close{
        font-size:24px !important;
        }
    }
  }
   .divImgWrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .itemImg{
        position: relative;
        margin: 5px 50px 5px 0px;
    }
   }
   .fileValueWrap{
    display: flex;
    align-items: center;
    min-height: 40px;
    .fileValueName{
        max-width: 240px;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
   }
   .close-wrap{
      position: absolute;
      cursor: pointer;
      top: -2px;
      right: -2px;
      width:25px;
      height:25px;
      background:#fff;
      border-radius:50%;
      display:flex;
      z-index:999;
    /deep/ .el-icon-circle-close{
      font-size:24px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/inputRule/index.vue